import { createContext, useContext } from 'react';

/**
 * Whether field-level validation errors are shown. The purchase wizard keeps an
 * untouched form calm and reveals every error after the first „Dalej”; any
 * other surface keeps the default (always shown).
 */
export const InvoiceIssueVisibility = createContext<boolean>(true);

export const useInvoiceIssuesVisible = () => useContext(InvoiceIssueVisibility);
